import { VideoSettingsData, IFieldDisplayData } from "widgets/commonDataObjects/interfaces"
import { SiteItemData } from "widgets/interfaces"
import { MultiImagesItemFrontMobile } from "./frontItemMobile";
import { ArticleData } from "articlePage/stateInterfaces"

interface MultiImagesFrontProps {
    itemList: SiteItemData[]
    width: number
    fieldsDisplaySettings: IFieldDisplayData
    videoSettings: VideoSettingsData
    imageWidth: number
    imageHeight: number
    titleColor: string
    isYplusComp?: boolean
    displayType: string
    isSpecial?: boolean
    isImageOnly?: boolean
    getArticle(articleId: string): ArticleData
}

export class MultiImagesYplusFrontMobile extends React.Component<MultiImagesFrontProps>{
    public static siteScriptName = "MultiImagesYplusFrontMobile";
    
    public render() {
        const { imageWidth, itemList, imageHeight, videoSettings, fieldsDisplaySettings, titleColor, isYplusComp, getArticle, displayType, isSpecial, isImageOnly } = this.props
        const className = `slotList ${isImageOnly ? "imageOnly" : ""}`;

        return (
            <div className="slotsContent">
                <div className={className}>
                    {itemList.map((slot, index) => {
                        return (
                            <MultiImagesItemFrontMobile
                                imageWidth={imageWidth}
                                index={index}
                                imageHeight={imageHeight}
                                videoSettings={videoSettings}
                                fieldsDisplaySettings={fieldsDisplaySettings}
                                item={slot}
                                titleColor={titleColor}
                                isYplusComp={isYplusComp}
                                isMutamView={true}
                                getArticle={getArticle}
                                displayType={displayType}
                                isSpecial={isSpecial}
                                isImageOnly={isImageOnly}
                            />
                        )
                    })}
                </div>
            </div>
        )
    }
}